/* BKS - provenance du client dans les liens de reprise des configurateurs (04/10/2026, Arthur).
   Chargé uniquement sur les 3 configurateurs qui créent un lien de reprise, avant leur propre script :
   FUSION (templates/page.creer-ma-selle-fusion.liquid, lien ?s=), scooter (page.creer-ma-selle-scooter.liquid,
   lien ?c=) et selle custom (page.cree-ma-selle-custom.json, lien #cfg=). Ne modifie aucun de leurs scripts.
   1) Quand le client copie le lien de sa selle (« Copier le lien ») ou se l'envoie par e-mail (Klaviyo,
      formulaire de contact), on ajoute au lien la provenance de sa visite : utm_* et identifiant de clic
      Google / Meta / TikTok / Bing, lus dans l'adresse de la page ou, à défaut, dans les attributs du
      panier (écrits par wetracked dès la 1re page). Sans provenance connue : utm_source=lien_reprise.
      Résultat : un retour plus tard ou sur un autre appareil garde la source d'origine.
      Si la copie est bloquée par le navigateur, le lien affiché à la place est complété aussi.
   2) Quand le client revient par un lien de reprise (?s=, ?c= ou #cfg=), on note bks_reprise dans
      le panier : la commande le garde dans ses informations supplémentaires.
   Aucun cookie ni stockage sur l'appareil. En cas de souci, tout retombe sur le comportement d'origine. */

/* ── 05/10/2026 — lot « tracking » (Ludo : « que l'UTM de Klaviyo ne perturbe pas l'UTM de la pub ») ──────────
   AJOUTS signés ; le travail d'Arthur ci-dessous est GARDÉ, avec les retouches signées « tracking 05/10 »
   (liste exacte au point B et au point D). Rapport et preuves : site/rapports/0510-tracking.md (scripts
   site/outils/0510/tracking/ et site/outils/0510/tracking/tour1/).

   MESURÉ AVANT D'ÉCRIRE (05/10) :
   · Klaviyo REMPLACE sur place, dans chaque lien, les utm que son réglage de compte ajoute (utm_source=Klaviyo,
     utm_medium=email) et laisse tous les autres paramètres : lien MICKA écrit « utm_source=klaviyo…
     &utm_campaign=bienvenue_vip » → arrivée réelle « utm_source=Klaviyo…&utm_campaign=bienvenue_vip&_kx=… ».
   · Depuis le 04/10, la provenance PUB mise par ce fichier dans le lien du mail « Selle FUSION sauvegardée »
     arrivait ainsi (05/10 11:30 UTC) : « utm_source=Klaviyo & utm_medium=email & utm_campaign=20782894259
     (campagne GOOGLE ADS) & gclid & gbraid » — un hybride : ni la pub ni le mail ne se lisent, et le gclid d'un
     ancien clic est rejoué par un mail.
   · wetracked range les utm dans le panier CLÉ PAR CLÉ, en dernière touche : pub Meta puis clic Klaviyo →
     utm_source=Klaviyo, utm_medium=email, mais utm_campaign et utm_content de la pub Meta.
   · (tour 1, soir) Les pubs Google Shopping / Performance Max arrivent avec les utm EN DOUBLE : d'abord ceux du
     flux produit de l'appli Google de Shopify (utm_medium=product_sync, utm_campaign=sag_organic), puis le
     suffixe Google Ads (utm_medium=cpc, utm_campaign=<id>) et gad_source / gad_campaignid / gclid / gbraid.
     Commandes réelles #BKS16417 et #BKS16411. URLSearchParams.get rend la 1re valeur : « product_sync /
     sag_organic » au lieu de « cpc / <campagne> » (wetracked fait la même erreur dans ses attributs).

   CE QUE ÇA CHANGE :
   A. PROVENANCE, partout où ce fichier est chargé : à l'arrivée, deux familles d'attributs du panier, À CÔTÉ de
      ceux de wetracked (jamais touchés). Les attributs du panier partent dans la commande (admin › commande ›
      « Informations supplémentaires ») :
        bks_pub_*   la 1re touche PUBLICITAIRE du panier, JAMAIS écrasée (ni par un clic de mail, ni par une
                    autre pub : celle-ci va dans bks_pub_derniere) ;
        bks_mail_*  la DERNIÈRE touche Klaviyo (_kx ou utm_source=klaviyo dans l'adresse).
      « Publicité » = la règle de snippets/bks-halloween.liquid (mesurée le 02/10 sur les commandes) : support
      payant, identifiant de clic pub (gclid, gbraid, wbraid, ttclid, msclkid, dclid), ou source pub sans support
      gratuit ; un fbclid SEUL n'est pas une pub (Meta l'ajoute à tout clic sortant, organique compris).
      utm lus par utmPropres() : le DERNIER bloc d'utm de l'adresse, et un clic Google Ads (gclid, gbraid,
      wbraid, gad_source, gad_campaignid) au support gratuit (product_sync) = google / cpc / gad_campaignid.
      Campagne d'un clic Google Ads : gad_campaignid d'abord (l'identifiant que Google met lui-même).
      Ni cookie, ni stockage navigateur : on écrit dans un panier qui EXISTE déjà (wetracked le crée sur les
      pages ordinaires ; l'ajout au panier le crée sur les configurateurs) ; s'il n'existe pas, on n'en crée un
      (cookie « cart ») qu'après un consentement CookieFirst (mesure ou publicité) — sinon on attend l'ajout au
      panier (point D) ou on renonce, sans rien poser.
      bks_pub_clic : le TYPE de l'identifiant de clic (gclid, fbclid…) ; sa VALEUR seulement si le visiteur a
      accepté la catégorie « publicité » de CookieFirst (window.CookieFirst.consent.advertising).
   B. ⛔ 08/10/2026 : CE POINT EST ANNULÉ pour les liens de l'événement Klaviyo — ils redeviennent ceux d'Arthur à
      l'identique (voir « PROTECTION DES FLUX D'ARTHUR » plus bas ; consigne de Ludo, pub Meta). Texte d'origine :
      LIENS ENVOYÉS PAR KLAVIYO (événement « … sauvegardée ») : plus aucun utm ni identifiant de clic pub dans le
      lien (Klaviyo y met les siens et écrasait source et support) ; la 1re touche pub voyage dans UN paramètre
      neutre que ni Klaviyo, ni Google, ni Meta ne lisent : bks_pub=source|support|campagne|clic|date (le TYPE
      du clic, jamais sa valeur). A le relit à l'arrivée (autre appareil compris) et le range dans bks_pub_* si
      le panier n'en a pas.
      Liens copiés ou envoyés par le client lui-même (presse-papiers, mailto, formulaire de contact) : bks_pub
      est ajouté ; les utm + identifiants de clic d'Arthur y restent QUAND la provenance vient de l'adresse de
      la page (arrivée de pub sur le configurateur) ou des SEULS attributs de wetracked. CHANGEMENTS par rapport
      à la version d'Arthur du 4 octobre (à lui de les connaître) : (1) quand le panier connaît bks_pub_*, le lien copié porte les utm de
      cette 1re pub SANS identifiant de clic (pas de gclid / fbclid rejoué) ; (2) après une arrivée par un mail,
      les utm Klaviyo de l'adresse ne sont plus recopiés comme provenance (ni un utm_source=Klaviyo de
      wetracked) ; (3) utm lus par utmPropres() (dernier bloc, voir A).
   C. Mode « site » : chargé par layout/theme.liquid avec data-bks-src="site", ce fichier ne fait QUE A (aucun
      crochet sur fetch ni sur le presse-papiers hors des configurateurs, qui le chargent eux-mêmes). Les deux
      chargements sur une même page ne font jamais A deux fois (window.BKS_SRC_PROV).
   D. (tour 1, soir) Configurateurs : FUSION et SCOOTER (gabarits autonomes) n'ont pas de panier avant l'ajout,
      et partent vers /cart dès la réponse de /cart/add.js. Le crochet fetch d'Arthur attend donc, sur un
      /cart/add.js réussi, que les attributs bks_* EN ATTENTE soient écrits (au plus 1,5 s) avant de rendre la
      réponse : le panier vient d'être créé par l'ajout, rien n'est créé de plus. bks_reprise (Arthur) passe par
      le même écrivain : il ne crée plus de panier sans consentement (avant : POST /cart/update.js à 3 s sur
      tout lien de reprise, panier créé) ; il est écrit dès que le panier existe (ajout compris). */
(function () {
  'use strict';
  var moi = document.currentScript;
  var modeSite = !!(moi && moi.getAttribute && moi.getAttribute('data-bks-src') === 'site');
  var fetchNatif = window.fetch;   /* avant tout crochet : la provenance n'a pas à passer par le crochet d'Arthur */

  /* ===== A. provenance (lot tracking, 05/10) ===== */
  var PAYANT = /^(cpc|ppc|cpm|cpa|cpv|paid|paid[_-]?social|paidsocial|social[_-]?paid|paid[_-]?search|ads?|display|retargeting)$/;
  var SOURCE_PUB = /^(facebook|fb|instagram|ig|meta|google|tiktok)$/;
  var GRATUIT = /^(organic|free|referral|e-?mail|newsletter|sms|social|product_sync|affiliation|affiliate|partenaire|partner)$/;
  var CLICS_PUB = ['gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid', 'dclid'];
  var PLATEFORME = { gclid: 'google', gbraid: 'google', wbraid: 'google', dclid: 'google', ttclid: 'tiktok', msclkid: 'microsoft', fbclid: 'meta' };
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];

  function net(v, n) { return String(v == null ? '' : v).replace(/[\u0000-\u001f|]+/g, ' ').replace(/^\s+|\s+$/g, '').slice(0, n || 100); }
  function jour() { return new Date().toISOString().slice(0, 10); }
  function horodatage() { return new Date().toISOString().slice(0, 16).replace('T', ' ') + ' UTC'; }
  function params() { try { return new URLSearchParams(location.search); } catch (e) { return null; } }

  /* tracking 05/10 soir (tour 1) — les utm d'une adresse, LUS PROPREMENT.
     1. utm en double (pubs Google Shopping / PMax, voir l'en-tête) : on ne garde que le DERNIER bloc, qui commence
        à la 1re clé utm vue une 2e fois ; les clés du 1er bloc absentes du dernier (utm_content=sag_organic du flux
        produit) sont écartées avec lui. Sans doublon, rien ne change.
     2. Un clic Google Ads (gclid, gbraid, wbraid, gad_source, gad_campaignid) dont le support n'est pas payant
        (adresse du flux produit SANS le suffixe d'Arthur, forme relevée dans les arrivées réelles : seulement
        « product_sync / sag_organic » + gad_source + gad_campaignid + gclid) est un clic payant : google / cpc /
        gad_campaignid.
        Jamais pour un lien de mail Klaviyo (_kx ou utm_source=klaviyo : géré par toucheMail ; un vieux lien de
        mail qui porte encore un gclid reste un clic de MAIL). */
  function utmPropres(P) {
    var o = {};
    if (!P) return o;
    var paires = [], vu = {}, debutBloc = 0, i, k;
    try { P.forEach(function (v, cle) { paires.push([cle, v]); }); } catch (e) { return o; }
    for (i = 0; i < paires.length; i++) {
      k = paires[i][0];
      if (UTM.indexOf(k) === -1) continue;
      if (vu[k]) { debutBloc = i; break; }
      vu[k] = true;
    }
    for (i = debutBloc; i < paires.length; i++) {
      if (UTM.indexOf(paires[i][0]) !== -1 && paires[i][1]) o[paires[i][0]] = String(paires[i][1]);
    }
    var ads = P.get('gclid') || P.get('gbraid') || P.get('wbraid') || P.get('gad_source') || P.get('gad_campaignid');
    var med = String(o.utm_medium || '').toLowerCase();
    if (ads && !PAYANT.test(med) && !/klaviyo/i.test(o.utm_source || '') && !P.get('_kx')) {
      var duFlux = !med || GRATUIT.test(med);
      o.utm_source = (o.utm_source && !duFlux) ? o.utm_source : 'google';
      o.utm_medium = 'cpc';
      o.utm_campaign = P.get('gad_campaignid') || (duFlux ? '' : (o.utm_campaign || ''));
      if (!o.utm_campaign) delete o.utm_campaign;
      if (duFlux) delete o.utm_content;
    }
    return o;
  }

  /* une arrivée de mail Klaviyo : _kx (identifiant de Klaviyo, ajouté à chaque lien suivi) ou utm_source=klaviyo */
  function toucheMail(P) {
    if (!P) return null;
    var U = utmPropres(P), so = U.utm_source || '';
    if (!P.get('_kx') && !/klaviyo/i.test(so)) return null;
    var ancien = false;   /* lien d'avant ce lot : provenance pub recopiée dans le lien → sa campagne est celle de la pub */
    for (var i = 0; i < CLICS_PUB.length; i++) { if (P.get(CLICS_PUB[i])) ancien = true; }
    if (P.get('fbclid')) ancien = true;
    return { source: net(so || 'klaviyo', 60), support: net(U.utm_medium || 'email', 60),
             campagne: ancien ? '' : net(U.utm_campaign, 120), contenu: ancien ? '' : net(U.utm_content, 120), ancien: ancien };
  }

  /* une arrivée de PUBLICITÉ (jamais un clic de mail) */
  function touchePub(P) {
    if (!P || toucheMail(P)) return null;
    var U = utmPropres(P);
    var so = (U.utm_source || '').toLowerCase(), med = (U.utm_medium || '').toLowerCase(), clic = '';
    for (var i = 0; i < CLICS_PUB.length; i++) { if (P.get(CLICS_PUB[i])) { clic = CLICS_PUB[i]; break; } }
    if (!(PAYANT.test(med) || clic || (SOURCE_PUB.test(so) && !GRATUIT.test(med)))) return null;
    if (!clic && P.get('fbclid')) clic = 'fbclid';
    return { source: net(so || PLATEFORME[clic] || '', 60), support: net(med, 60),
             campagne: net(P.get('gad_campaignid') || U.utm_campaign || '', 120), contenu: net(U.utm_content, 120),
             clic: clic, clicValeur: clic ? net(P.get(clic), 250) : '', date: jour(), origine: 'arrivée' };
  }

  /* la 1re touche pub qui voyage dans un lien de reprise envoyé par mail (point B) */
  function touchePorte(P) {
    var v = P && P.get('bks_pub');
    if (!v) return null;
    var t = String(v).split('|');
    if (t.length < 2 || !net(t[0], 60)) return null;
    return { source: net(t[0], 60), support: net(t[1], 60), campagne: net(t[2], 120), contenu: '', clic: net(t[3], 20),
             clicValeur: '', date: net(t[4], 10), origine: 'lien de reprise' };
  }

  /* lien d'avant ce lot : la pub y était recopiée (utm_campaign + identifiant de clic) */
  function pubDansAncienLien(P) {
    var m = toucheMail(P);
    if (!m || !m.ancien) return null;
    var clic = '';
    for (var i = 0; i < CLICS_PUB.length; i++) { if (P.get(CLICS_PUB[i])) { clic = CLICS_PUB[i]; break; } }
    if (!clic && P.get('fbclid')) clic = 'fbclid';
    return { source: PLATEFORME[clic] || '', support: '', campagne: net(utmPropres(P).utm_campaign, 120), contenu: '', clic: clic,
             clicValeur: '', date: '', origine: 'ancien lien de mail' };
  }

  function porteChaine(t) {
    if (!t || !t.source) return '';
    return [t.source, t.support, t.campagne, t.clic, (t.date || jour()).slice(0, 10)].map(function (x) { return net(x, 120); }).join('|');
  }

  function panierExiste() { try { return /(^|;\s*)cart=/.test(document.cookie); } catch (e) { return false; } }
  function consentement() {
    try { var c = window.CookieFirst && window.CookieFirst.consent; return !!(c && (c.performance || c.advertising)); } catch (e) { return false; }
  }
  /* tracking 05/10 soir : la VALEUR d'un identifiant de clic (gclid=…, fbclid=…) n'est rangée qu'avec la catégorie
     « publicité » de CookieFirst ; sans elle, le type seul (« gclid ») */
  function consentementPub() {
    try { var c = window.CookieFirst && window.CookieFirst.consent; return !!(c && c.advertising); } catch (e) { return false; }
  }
  function clicRange(t) {
    if (!t || !t.clic) return '';
    return t.clic + (t.clicValeur && consentementPub() ? '=' + t.clicValeur : '');
  }

  /* ===== l'ÉCRIVAIN d'attributs du panier (tracking 05/10 soir, tour 1) =====
     Une seule file pour tout ce que ce fichier écrit dans le panier (bks_pub_*, bks_mail_*, bks_reprise).
     Chaque demande est une fonction : attributs ACTUELS du panier → attributs à écrire (calculés au moment de
     l'écriture : la 1re pub n'est jamais écrasée). Écriture :
       · 3,5 s après l'arrivée (après wetracked, qui écrit le panier à la 1re seconde, et le bloc fbclid du
         layout à 2,5 s) si le panier existe ou si le visiteur a consenti ; sinon on regarde le cookie « cart »
         toutes les 5 s pendant 20 min (une lecture de chaîne), et tout de suite au consentement (cf_consent) ;
       · TOUT DE SUITE après un ajout au panier réussi sur un configurateur (point D, apresAjout), avant que la
         page ne parte vers /cart ;
       · relue après écriture (une écriture concurrente peut nous perdre) : 2 reprises.
     Mesuré (05/10, banc fermé du vérificateur et parcours T5) : sur FUSION et SCOOTER, aucun panier avant
     l'ajout ; l'ajout redirige vers /cart dès la réponse → sans le point D, la touche était perdue. */
  var attente = [], enCours = null, minuteur = null, reprises = 0, debut = Date.now();

  function lirePanier() {
    return fetchNatif.call(window, '/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function ecrireMaintenant() {
    if (!attente.length) return Promise.resolve(true);
    if (enCours) return enCours;
    if (!panierExiste() && !consentement()) return Promise.resolve(false);   /* on ne crée pas de panier sans consentement */
    var lot = attente.slice(), u = {};
    enCours = lirePanier().then(function (c) {
      if (!c) return false;
      var a = c.attributes || {}, change = false, k;
      lot.forEach(function (f) {
        var x = {};
        try { x = f(a) || {}; } catch (e) {}
        for (var cle in x) { if (Object.prototype.hasOwnProperty.call(x, cle)) u[cle] = String(x[cle]); }
      });
      for (k in u) { if (Object.prototype.hasOwnProperty.call(u, k) && String(a[k] || '') !== u[k]) change = true; }
      if (!change) return true;
      /* keepalive : si la réponse de l'ajout part avant la fin (attente bornée à 1,5 s) et que la page s'en va vers
         /cart, le navigateur termine quand même cette requête (corps de quelques centaines d'octets) */
      return fetchNatif.call(window, '/cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: u })
      }).then(function () { return lirePanier(); }).then(function (c2) {
        var b = (c2 && c2.attributes) || {};
        for (var k2 in u) { if (Object.prototype.hasOwnProperty.call(u, k2) && u[k2] && b[k2] !== u[k2] && k2 !== 'bks_pub_derniere') return false; }
        return true;
      });
    }).then(function (ok) {
      enCours = null;
      if (ok) attente = attente.filter(function (f) { return lot.indexOf(f) === -1; });
      return ok;
    }, function () { enCours = null; return false; });
    return enCours;
  }

  function tic() {
    minuteur = null;
    if (!attente.length) return;
    if (!panierExiste() && !consentement()) {
      if (Date.now() - debut < 20 * 60000) minuteur = setTimeout(tic, 5000);
      return;
    }
    ecrireMaintenant().then(function (ok) {
      if (!ok && attente.length && ++reprises <= 2 && !minuteur) minuteur = setTimeout(tic, 3000);
    });
  }

  function demander(f, delai) {
    attente.push(f);
    if (!minuteur) minuteur = setTimeout(tic, delai == null ? 3500 : delai);
  }

  /* point D : appelé par le crochet fetch des configurateurs sur un /cart/add.js RÉUSSI ; rend la réponse
     d'origine, intacte, au plus 1,5 s plus tard */
  function apresAjout(reponse) {
    if (!reponse || !reponse.ok || !attente.length) return reponse;
    return new Promise(function (rendre) {
      var fini = false;
      function fin() { if (!fini) { fini = true; rendre(reponse); } }
      setTimeout(fin, 1500);
      /* une écriture déjà en cours (sondage) peut ne pas contenir une demande arrivée après elle : on en refait une */
      try { ecrireMaintenant().then(function () { return attente.length ? ecrireMaintenant() : true; }).then(fin, fin); } catch (e) { fin(); }
    });
  }

  try {
    window.addEventListener('cf_consent', function () {
      if (attente.length && consentement()) { if (minuteur) clearTimeout(minuteur); minuteur = setTimeout(tic, 300); }
    });
  } catch (e) {}

  function provenance() {
    var P = params();
    if (!P) return;
    var mail = toucheMail(P), porte = touchePorte(P) || pubDansAncienLien(P);
    /* un lien de reprise COPIÉ par le client porte bks_pub ET (choix d'Arthur) les utm / gclid de la pub d'origine :
       c'est la même touche rejouée, pas une nouvelle publicité → on garde la date et l'origine de bks_pub */
    var pub = porte ? null : touchePub(P);
    if (!mail && !pub && !porte) return;
    var page = net(location.pathname, 120), quand = horodatage();   /* l'heure de l'ARRIVÉE, pas de l'écriture */

    demander(function (a) {
      var u = {}, premiere = pub || porte;
      if (premiere) {
        if (!a.bks_pub_source) {
          u.bks_pub_source = premiere.source || '?';
          u.bks_pub_support = premiere.support || '';
          u.bks_pub_campagne = premiere.campagne || '';
          u.bks_pub_contenu = premiere.contenu || '';
          u.bks_pub_clic = clicRange(premiere);
          u.bks_pub_date = pub ? quand : (premiere.date || '');
          u.bks_pub_page = pub ? page : '';
          u.bks_pub_origine = premiere.origine;
        } else if (pub) {
          var resume = [pub.source, pub.support, pub.campagne].join(' / ');
          var dejaVu = [a.bks_pub_source, a.bks_pub_support, a.bks_pub_campagne].join(' / ');
          if (resume !== dejaVu) u.bks_pub_derniere = net(resume + ' · ' + quand + ' · ' + page, 250);
        }
      }
      if (mail) {
        u.bks_mail_source = mail.source;
        u.bks_mail_support = mail.support;
        u.bks_mail_campagne = mail.campagne;   /* '' efface la campagne d'un mail précédent : c'est une DERNIÈRE touche */
        u.bks_mail_contenu = mail.contenu;
        u.bks_mail_date = quand;
        u.bks_mail_page = page;
      }
      return u;
    });

    /* consentement « publicité » donné APRÈS l'arrivée, sur cette page : on complète la valeur du clic, seulement
       si la 1re pub du panier est bien celle-ci (même source, même date d'arrivée, type seul) */
    if (pub && pub.clic && pub.clicValeur) {
      try {
        window.addEventListener('cf_consent', function () {
          if (!consentementPub()) return;
          demander(function (a) {
            if (a.bks_pub_source === (pub.source || '?') && a.bks_pub_date === quand && a.bks_pub_clic === pub.clic) {
              return { bks_pub_clic: pub.clic + '=' + pub.clicValeur };
            }
            return {};
          }, 300);
        });
      } catch (e) {}
    }
  }

  if (!window.BKS_SRC_PROV) {
    window.BKS_SRC_PROV = { demander: demander, ecrireMaintenant: ecrireMaintenant, apresAjout: apresAjout };   /* tracking 05/10 soir */
    try { provenance(); } catch (e) {}
  }
  if (modeSite) return;   /* point C : hors configurateurs, rien d'autre */

  /* ===== le travail d'Arthur (04/10), avec les retouches signées « tracking 05/10 » ===== */
  if (window.BKS_SRC) return;

  var CLES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
              'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var src = null;
  var capture = null;
  var P0 = params();
  var pubIci = touchePorte(P0) || pubDansAncienLien(P0) || touchePub(P0);   /* tracking 05/10 */
  var pubPanier = null;                                                        /* tracking 05/10 : bks_pub_* du panier */

  /* ── 08/10/2026 — PROTECTION DES FLUX D'ARTHUR (consigne de Ludo : « garde bien l'UTM qu'Arthur a mis sur le flux
     FUSION et le flux du configurateur scooter, c'est pub Meta ; il ne perd ni le lien ni le tracking ») ──────────
     Les liens de l'événement Klaviyo « … sauvegardée » (LienReprise, Config2Lien, Config3Lien → flux FUSION UD6jvr
     et SCOOTER Rydzqg, dont les 6 mails ont add_tracking_params = false : Klaviyo n'y touche pas aux utm) sont
     rendus EXACTEMENT comme dans la version d'Arthur du 04/10 (sha1 b7f554d0) : même provenance (adresse de la
     page, sinon attributs du panier, lus TELS QUELS), mêmes paramètres, même ordre, même repli
     « utm_source=lien_reprise » ; les propriétés SourceVisite / SupportVisite / CampagneVisite / ClicPub aussi.
     Le reste du lot tracking est inchangé : à l'arrivée par ce lien, pubDansAncienLien() range toujours la pub
     (identifiant de clic présent) dans bks_pub_*. Preuve : site/outils/0810/flux/audit/D7-banc-liens.js. */
  var srcArthur = (function () {
    var o = {}, p;
    try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    CLES.forEach(function (k) { var v = p.get(k); if (v) o[k] = String(v).slice(0, 250); });
    return vide(o) ? null : o;
  })();

  function vide(o) {
    for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) return false; }
    return true;
  }

  function lireParams(search) {
    var o = {}, p;
    try { p = new URLSearchParams(search); } catch (e) { return o; }
    var u = utmPropres(p);   /* tracking 05/10 soir : utm du DERNIER bloc, clic Google Ads au support gratuit = cpc */
    CLES.forEach(function (k) {
      var v = /^utm_/.test(k) ? u[k] : p.get(k);
      if (v) o[k] = String(v).slice(0, 250);
    });
    return o;
  }

  /* tracking 05/10 : une touche pub → la forme « src » d'Arthur (utm seulement : l'identifiant de clic n'est
     pas recopié, il resterait sinon rejoué par chaque lien) */
  function srcDePub(t) {
    var o = {};
    if (t.source) o.utm_source = t.source;
    if (t.support) o.utm_medium = t.support;
    if (t.campagne) o.utm_campaign = t.campagne;
    o._clic = t.clic || '';
    return o;
  }

  /* 1. la page elle-même : arrivée directe sur le configurateur depuis une pub
        (tracking 05/10 : un clic de MAIL n'est pas une provenance à recopier — c'était « utm_source=Klaviyo » dans
        les liens copiés ; une arrivée par lien de reprise porteur de bks_pub reprend la pub d'origine) */
  var ici = lireParams(location.search);
  if (toucheMail(P0)) { if (pubIci) src = srcDePub(pubIci); }
  else if (touchePorte(P0)) src = srcDePub(touchePorte(P0));
  else if (!vide(ici)) src = ici;

  /* 2. sinon les attributs du panier : d'abord la 1re touche pub (bks_pub_*, tracking 05/10), puis ceux de
        wetracked (utm + identifiants de clic, dernière touche clé par clé — un utm_source=Klaviyo n'y est pas
        une provenance : on n'en garde que les identifiants de clic ; tracking 05/10 soir : lus par utmPropres,
        wetracked gardant lui aussi le « product_sync » du flux produit) */
  function chargerPanier() {
    try {
      fetchNatif.call(window, '/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          var a = (c && c.attributes) || {}, o, q;
          var oa = {};   /* 08/10 : la provenance d'Arthur, lue comme il la lisait (attributs du panier tels quels) */
          CLES.forEach(function (k) { if (a[k]) oa[k] = String(a[k]).slice(0, 250); });
          if (!srcArthur && !vide(oa)) srcArthur = oa;
          if (a.bks_pub_source) {
            var cl = String(a.bks_pub_clic || '').split('=')[0];
            pubPanier = { source: a.bks_pub_source, support: a.bks_pub_support || '', campagne: a.bks_pub_campagne || '',
                          clic: cl, date: String(a.bks_pub_date || '').slice(0, 10) };
          }
          q = new URLSearchParams();
          CLES.forEach(function (k) { if (a[k]) q.append(k, String(a[k])); });
          o = lireParams('?' + q.toString());
          if (/klaviyo/i.test(o.utm_source || '')) {
            ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'].forEach(function (k) { delete o[k]; });
          }
          if (!src && pubPanier) src = srcDePub(pubPanier);
          else if (!src && !vide(o)) src = o;
        })['catch'](function () {});
    } catch (e) {}
  }

  function estLienReprise(u) {
    return typeof u === 'string' &&
      u.indexOf(location.host) !== -1 &&
      (/\/pages\/cree-ta-selle[^?#\s]*\?(?:[^#\s]*&)?[sc]=/.test(u) ||
       /\/pages\/creer-ma-selle-custom[^#\s]*#cfg=/.test(u) ||
       /* 16/10/2026 (Arthur) : configurateurs ouverts depuis une fiche produit, lien /products/<fiche>?view=…-config&s=… */
       (/\/products\/[^?#\s]+\?(?:[^#\s]*&)?view=[\w-]+-config(?:[&#]|$)/.test(u) && /[?&]s=/.test(u)));
  }

  /* tracking 05/10 : la valeur de bks_pub — 1re touche du panier, sinon celle de cette arrivée, sinon une
     provenance de wetracked qui EST une pub selon la règle commune */
  function valeurPorte() {
    var t = pubPanier || pubIci;
    if (!t && src && !vide(src)) {
      try {
        var q = new URLSearchParams();
        for (var k in src) { if (Object.prototype.hasOwnProperty.call(src, k) && k !== '_clic' && src[k]) q.set(k, src[k]); }
        t = touchePub(q);
      } catch (e) {}
    }
    return porteChaine(t);
  }

  /* ajoute la provenance à la fin du lien, sans toucher à la config encodée dans ?s= / ?c=
     tracking 05/10 : pourMail = lien envoyé par Klaviyo → seulement bks_pub (point B) */
  function ajouterSource(u, pourMail) {
    try {
      if (!estLienReprise(u)) return u;
      var o = src || {}, ajouts = [];
      function present(k) { return new RegExp('[?&]' + k + '=').test(u); }
      var bp = valeurPorte();
      if (pourMail) {
        if (bp && !present('bks_pub')) ajouts.push('bks_pub=' + encodeURIComponent(bp));
      } else {
        if (vide(o)) {
          if (!present('utm_source')) {
            ajouts.push('utm_source=lien_reprise', 'utm_medium=configurateur',
                        'utm_campaign=' + quelConfigurateur(u));
          }
        } else {
          CLES.forEach(function (k) {
            if (o[k] && !present(k)) ajouts.push(k + '=' + encodeURIComponent(o[k]));
          });
        }
        if (bp && !present('bks_pub')) ajouts.push('bks_pub=' + encodeURIComponent(bp));
      }
      if (!ajouts.length) return u;
      var h = u.indexOf('#'), base = h === -1 ? u : u.slice(0, h), fin = h === -1 ? '' : u.slice(h);
      return base + (base.indexOf('?') === -1 ? '?' : '&') + ajouts.join('&') + fin;
    } catch (e) { return u; }
  }

  /* 08/10 : la fonction d'Arthur du 04/10, À L'IDENTIQUE, sur srcArthur — pour les liens envoyés par Klaviyo */
  function ajouterSourceArthur(u) {
    try {
      if (!estLienReprise(u)) return u;
      var o = srcArthur || {}, ajouts = [];
      function present(k) { return new RegExp('[?&]' + k + '=').test(u); }
      if (vide(o)) {
        if (!present('utm_source')) {
          ajouts.push('utm_source=lien_reprise', 'utm_medium=configurateur',
                      'utm_campaign=' + quelConfigurateur(u));
        }
      } else {
        CLES.forEach(function (k) {
          if (o[k] && !present(k)) ajouts.push(k + '=' + encodeURIComponent(o[k]));
        });
      }
      if (!ajouts.length) return u;
      var h = u.indexOf('#'), base = h === -1 ? u : u.slice(0, h), fin = h === -1 ? '' : u.slice(h);
      return base + (base.indexOf('?') === -1 ? '?' : '&') + ajouts.join('&') + fin;
    } catch (e) { return u; }
  }

  function quelConfigurateur(u) {
    var vue = /[?&]view=([\w-]+)-config(?:[&#]|$)/.exec(u);   /* 16/10/2026 (Arthur) : premium, fusion-sm, dirt, labks */
    if (vue) return vue[1];
    return /creer-ma-selle-custom/.test(u) ? 'custom' : (/scooter/.test(u) ? 'scooter' : 'fusion');
  }

  function clicPub(o) {
    if (o.gclid || o.gbraid || o.wbraid) return 'google';
    if (o.fbclid) return 'meta';
    if (o.ttclid) return 'tiktok';
    if (o.msclkid) return 'bing';
    if (o._clic) return PLATEFORME[o._clic] === 'microsoft' ? 'bing' : (PLATEFORME[o._clic] || 'aucun');   /* tracking 05/10 */
    return 'aucun';
  }

  /* événement Klaviyo « Selle … sauvegardée » : liens complétés + provenance dans les propriétés */
  function corrigerKlaviyo(s) {
    try {
      var j = JSON.parse(s), at = j && j.data && j.data.attributes, p = at && at.properties;
      var nom = at && at.metric && at.metric.data && at.metric.data.attributes && at.metric.data.attributes.name;
      if (!p || typeof p !== 'object' || !/sauvegard/i.test(String(nom || ''))) return s;
      for (var k in p) {
        if (Object.prototype.hasOwnProperty.call(p, k) && /Lien/.test(k) && typeof p[k] === 'string') {
          p[k] = ajouterSourceArthur(p[k]);   /* 08/10 : lien de MAIL = lien d'Arthur à l'identique (flux protégés) */
        }
      }
      var o = srcArthur || {};              /* 08/10 : propriétés de provenance = celles d'Arthur */
      if (vide(o)) {
        p.SourceVisite = 'inconnue';
      } else {
        var c = clicPub(o);
        p.SourceVisite = o.utm_source || (c !== 'aucun' ? c : 'inconnue');
        if (o.utm_medium) p.SupportVisite = o.utm_medium;
        if (o.utm_campaign) p.CampagneVisite = o.utm_campaign;
        p.ClicPub = c;
      }
      return JSON.stringify(j);
    } catch (e) { return s; }
  }

  function copier(init, modif) {
    var o = {}, k;
    for (k in init) { if (Object.prototype.hasOwnProperty.call(init, k)) o[k] = init[k]; }
    for (k in modif) { if (Object.prototype.hasOwnProperty.call(modif, k)) o[k] = modif[k]; }
    return o;
  }

  /* fetch : on ne touche qu'à l'événement Klaviyo et au formulaire de contact, le reste passe tel quel
     (tracking 05/10 soir, point D : sur un /cart/add.js réussi, la RÉPONSE est rendue après l'écriture des
     attributs bks_* en attente, au plus 1,5 s ; la requête elle-même n'est pas modifiée) */
  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    var fetchBks = function (input, init) {
      var ajout = false;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var methode = String((init && init.method) || (input && typeof input !== 'string' && input.method) || 'GET');
        ajout = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url) && /^post$/i.test(methode);   /* tracking 05/10 soir */
        if (init && init.body) {
          if (/^https:\/\/a\.klaviyo\.com\/client\/events\//.test(url) && typeof init.body === 'string') {
            init = copier(init, { body: corrigerKlaviyo(init.body) });
          } else if (/^\/contact(?:[?#]|$)/.test(url) && typeof URLSearchParams !== 'undefined' &&
                     init.body instanceof URLSearchParams) {
            var b = init.body.get('contact[body]');
            if (b) init.body.set('contact[body]', b.replace(/https?:\/\/[^\s]+/g, function (m) { return ajouterSource(m); }));
          }
        }
      } catch (e) {}
      var reponse = fetchOrigine.call(window, input, init);
      if (ajout && window.BKS_SRC_PROV && typeof window.BKS_SRC_PROV.apresAjout === 'function') {
        try { return reponse.then(window.BKS_SRC_PROV.apresAjout); } catch (e) {}
      }
      return reponse;
    };
    fetchBks.bks = true;
    window.fetch = fetchBks;
  }

  /* presse-papiers : « Copier le lien » des trois configurateurs */
  try {
    var cb = navigator.clipboard;
    if (cb && typeof cb.writeText === 'function') {
      var ecrireOrigine = cb.writeText;
      var ecrireBks = function (t) {
        if (capture) { capture(t); return Promise.resolve(); }
        return ecrireOrigine.call(cb, ajouterSource(t));
      };
      ecrireBks.bks = true;
      try { cb.writeText = ecrireBks; } catch (e) {}
      if (cb.writeText !== ecrireBks && window.Clipboard && Clipboard.prototype.writeText) {
        var protoOrigine = Clipboard.prototype.writeText;
        Clipboard.prototype.writeText = function (t) {
          if (capture) { capture(t); return Promise.resolve(); }
          return protoOrigine.call(this, ajouterSource(t));
        };
      }
    }
  } catch (e) {}

  /* presse-papiers bloqué (navigateurs intégrés d'Instagram, TikTok…) : le configurateur affiche alors
     le lien à copier à la main dans #lok (FUSION), #scok (scooter) ou #sc-saveok (selle custom) ;
     on y affiche la version complétée */
  function corrigerAffichage() {
    ['lok', 'scok', 'sc-saveok'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var t = (el.textContent || '').trim();
      if (t && estLienReprise(t)) {
        var n = ajouterSource(t);
        if (n !== t) el.textContent = n;
      }
    });
  }
  try {
    if (window.MutationObserver && document.documentElement) {
      new MutationObserver(corrigerAffichage).observe(document.documentElement,
        { childList: true, subtree: true, characterData: true });
    }
  } catch (e) {}

  /* selle custom, « Me l'envoyer par email » : le configurateur ouvre directement la messagerie avec le
     lien. On récupère ce lien via son bouton « Copier le lien » (sans toucher au presse-papiers), puis on
     ouvre la même messagerie avec le lien complété. Au moindre souci, le bouton d'origine fait son travail. */
  try {
    document.addEventListener('click', function (e) {
      var mail = e.target && e.target.closest && e.target.closest('#sc-savemail');
      var copie = document.getElementById('sc-savelink');
      if (!mail || !copie || typeof copie.onclick !== 'function') return;
      var lien = null, ok = document.getElementById('sc-saveok'), avant = ok ? ok.textContent : null;
      capture = function (t) { lien = t; };
      try { copie.onclick.call(copie); } catch (err) {}
      capture = null;
      if (typeof lien !== 'string' || !estLienReprise(lien)) {
        if (ok) ok.textContent = avant;
        return;
      }
      e.stopImmediatePropagation();
      e.preventDefault();
      setTimeout(function () { if (ok) ok.textContent = avant; }, 30);
      location.href = 'mailto:?subject=' + encodeURIComponent('Ma selle custom BKS — lien de reprise') +
        '&body=' + encodeURIComponent('Reprends ta configuration ici :\n\n' + ajouterSource(lien));
    }, true);
  } catch (e) {}

  /* retour par un lien de reprise : on le note dans le panier (après l'écriture de wetracked)
     tracking 05/10 soir : par l'écrivain commun (point D) → plus de panier CRÉÉ sans consentement (le POST
     /cart/update.js d'origine, à 3 s, en créait un) ; écrit à 3 s si le panier existe, sinon dès l'ajout au
     panier ou au consentement. Même valeur qu'Arthur. */
  function noterReprise() {
    try {
      var p = new URLSearchParams(location.search);
      var custom = /creer-ma-selle-custom/.test(location.pathname) && location.hash.indexOf('#cfg=') === 0;
      if (!p.has('s') && !p.has('c') && !custom) return;
      var quoi = quelConfigurateur(location.pathname + (/[?&]view=[\w-]+-config/.test(location.search) ? location.search : ''));   /* 16/10 (Arthur) */
      var valeur = 'lien ' + quoi + ' ' + new Date().toISOString().slice(0, 10);
      var prov = window.BKS_SRC_PROV;
      if (prov && typeof prov.demander === 'function') prov.demander(function () { return { bks_reprise: valeur }; }, 3000);
    } catch (e) {}
  }

  chargerPanier();
  noterReprise();

  window.BKS_SRC = {
    source: function () { return src; },
    ajouterSource: ajouterSource,
    corrigerKlaviyo: corrigerKlaviyo,
    porte: valeurPorte,                                   /* tracking 05/10 */
    essai: function (o) { src = o || null; srcArthur = o || null; }   /* 08/10 : l'essai d'Arthur agit aussi sur ses liens de mail */
  };
})();
